export const Footer = () => {
    return (
        <footer className="sticky-footer bg-white">
            <div className="container my-auto">
                <div className="copyright text-center my-auto">
                    <span>Copyright &copy; Coluço System 2021</span><br /><br />
                    <span>Site criado por <strong style={{color: "#2E9F42"}}>RCode</strong>.</span>
                </div>
            </div>
        </footer>
    )
}